import React, { useEffect, useState } from 'react';
import { JobLog } from '../model/Log';
import { showMessage } from '../services/popup';
import { getJobLogs, getJobsNames } from '../services/service';

const SIZE = 50;

const JobsPage: React.FC = () => {
  const [page, setPage] = useState(0);
  const [logs, setLogs] = useState<JobLog[]>([]);
  const [jobsNames, setJobsNames] = useState<string[]>([]);
  const [pattern, setPattern] = useState('');

  const loadJobs = async (p: number, ptn?: string) => {
    try {
      setJobsNames(await getJobsNames());
      setLogs(await getJobLogs(ptn ?? pattern, p * SIZE, SIZE + 1, ''));
    } catch (e) {
      showMessage('Une erreur est survenue: ' + JSON.stringify(e));
    }
  };

  const hasNext = logs.length > SIZE;
  const hasPrevious = page > 0;

  const movePage = (next: number) => {
    if (next >= 0) {
      setPage(next);
      loadJobs(next);
    }
  };

  const search = (value?: string) => {
    const v = value ?? pattern;
    setPattern(v);
    setPage(0);
    loadJobs(0, v);
  };

  useEffect(() => {
    loadJobs(0, '');
  }, []);

  return (
    <div className="page-stack">
      <section className="panel">
        <div className="toolbar-row">
          <input value={pattern} onChange={(e) => setPattern(e.target.value)} placeholder="Recherche jobs" />
          <button className="primary-btn" onClick={() => search()}>Rechercher</button>
          <div className="pager-inline">
            <button className="ghost-btn" disabled={!hasPrevious} onClick={() => movePage(page - 1)}>Precedent</button>
            <span>Page {page + 1}</span>
            <button className="ghost-btn" disabled={!hasNext} onClick={() => movePage(page + 1)}>Suivant</button>
          </div>
        </div>

        <div className="chips-wrap">
          {jobsNames.map((name, i) => (
            <button key={i} className="chip-btn" onClick={() => search(name)}>{name}</button>
          ))}
        </div>

        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Job</th>
                <th>Duration</th>
                <th>Succes</th>
                <th>Start</th>
                <th>Data</th>
                <th>Erreur</th>
              </tr>
            </thead>
            <tbody>
              {logs.slice(0, SIZE).map((l, i) => (
                <tr key={i + 1}>
                  <td>{l.jobName}</td>
                  <td className="mono">{l.duration}</td>
                  <td><span className={`pill ${l.success ? 'ok' : 'bad'}`}>{l.success ? 'Oui' : 'Non'}</span></td>
                  <td>{new Date(l.start).toLocaleDateString()} {new Date(l.start).toLocaleTimeString()}</td>
                  <td>{l.data}</td>
                  <td>{l.error}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default JobsPage;
